export default __webpack_public_path__ + "static/Portrait-Bold-Web-798b54d77d3d4c7258ca742594f440d1.woff2";